import { ArrayField, Field } from "sparkson";
import { AnalyticsEndpoint } from "./AnalyticsEndpoint";
import { PlayerControls } from "./PlayerControls";
import { Skin } from "./Skin";

export class ConfigurationOverride {
  constructor(
    @Field("adminMode", true) public adminMode?: boolean,
    @Field("autoplay", true) public autoplay?: boolean,
    @Field("mutedStart", true) public mutedStart?: boolean,
    @Field("autoRefreshBeforeReady", true) public autoRefreshBeforeReady?: boolean,
    @Field("subtitlesActiveOnStart", true) public subtitlesActiveOnStart?: boolean,
    @ArrayField("analyticsEndpoints", AnalyticsEndpoint, true) public analyticsEndpoints?: AnalyticsEndpoint[],
    @Field("playerControls", true) public playerControls?: PlayerControls,
    @Field("skin", true) public skin?: Skin,
    @Field("playerServerUrl", true) public playerServerUrl?: string,
    @Field("ctaStorageUrl", true) public ctaStorageUrl?: string,
    @Field("jsAssetsUrl", true) public jsAssetsUrl?: string,
    @Field("playIconOnPoster", true) public playIconOnPoster?: boolean
  ) {}
}
